import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import colors from 'vuetify/lib/util/colors'
import preset from './default-preset/preset'

Vue.use(Vuetify)

export default new Vuetify({
  preset,
  colors,
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    dark: false,
    options: {
      customProperties: true,
      variations: false,
    },
  },
})
